import { useEffect, useState } from "react"

const TimeZoneLabel = ({ timeZone }: { timeZone: string }) => {
  const [currentTime, setCurrentTime] = useState("")

  useEffect(() => {
    const updateTime = () => {
      const now = new Date()
      const options: Intl.DateTimeFormatOptions = {
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        hour12: true,
        timeZone,
      }
      const formatter = new Intl.DateTimeFormat("en-US", options)
      setCurrentTime(formatter.format(now))
    }

    updateTime()
    const interval = setInterval(updateTime, 1000)
    return () => clearInterval(interval)
  }, [timeZone])

  return (
    <p className="timezone-label">
      Timezone: <strong>{timeZone}</strong> | Current Time:{" "}
      <strong>{currentTime}</strong>
    </p>
  )
}

export default TimeZoneLabel
